import classNames from 'classnames';
import { useState, useEffect, ReactNode } from 'react';
import { TAnimatedPageDirection } from './types';

type TAnimatedPageProps = {
  children: ReactNode;
  direction: TAnimatedPageDirection | null;
  duration: number;
};

export const AnimatedPage = ({ direction = null, children, duration }: TAnimatedPageProps) => {
  const [animation, setAnimation] = useState<string | null>(null);

  useEffect(() => {
    if (!direction) {
      setAnimation(null);
      return;
    }

    if (direction === 'forwards') {
      setAnimation('forwards-out');
      setTimeout(() => {
        setAnimation('forwards-in');
      }, duration);
    }

    if (direction === 'backwards') {
      setAnimation('backwards-out');
      setTimeout(() => {
        setAnimation('backwards-in');
      }, duration);
    }
  }, [direction, duration]);

  return (
    <div
      className={classNames(`transition-all duration-1000 delay-1000`, {
        'animate-forwards-in': animation === 'forwards-in',
        'animate-forwards-out': animation === 'forwards-out',
        'animate-backwards-in': animation === 'backwards-in',
        'animate-backwards-out': animation === 'backwards-out',
      })}
    >
      {children}
    </div>
  );
};
